export default __webpack_public_path__ + "static/media/logo_academia_fester_header.e1b34803.png";